import { bankDepositAPI } from "./mocks/mock.bank-deposit.api";
import { westernUnionAPI } from "./mocks/mock.western-union.api";

const mockapi = {
  // ...westernUnionAPI,
  // ...bankDepositAPI,
}
export default mockapi;
